<template>
  <BLayout
    class="container"
    align-center
    @click="handleClick"
  >
    <div class="user">
      <BUserTooltip
        :image-url="(nextAction.owner || {}).avatarUrl"
        :name="(nextAction.owner || {}).name"
        :user-id="(nextAction.owner || {}).id"
        :size="40"
      />
    </div>
    <div class="next-action-suggestion">
      <div class="content">
        <div class="fw-bold">
          {{ nextAction.name }}
        </div>
        <div
          class="priority-preview micro"
        >
          <BColorPreview
            :color-code="COLOR_CODES.VENUS"
            size="micro"
          />
          <span class="priority-name">{{ $t('nextActionSuggestion.status.none') }}</span>
        </div>
      </div>
      <div class="content">
        <div class="company-name">
          {{ nextAction.callTarget.companyName || $t('general.none') }}
        </div>
        <div class="full-name">
          {{ nextAction.callTarget.fullName || $t('general.none') }}
        </div>
      </div>
      <div class="content">
        <div
          class="expand-text"
          @click.stop
        >
          <BExpandableText
            :text="nextAction.content"
            :non-expanded-text-line="1"
          />
        </div>
      </div>
    </div>
  </BLayout>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import type { NextActionSuggestion } from '@/api/openapi';
import { useRouterLink } from '@/composable/router-link';
import COLOR_CODES from '@/const/color_codes';

type TProps = {
  nextAction: NextActionSuggestion;
};

const props = defineProps<TProps>();

const i18n = useI18n();
const { linkTo } = useRouterLink();

const handleClick = () => {
  linkTo({ name: 'LeadList', query: { callTargetId: props.nextAction.callTarget.id } }, true);
};
</script>

<style lang="scss" scoped>
.container {
  padding: $basespace-100 $basespace-300;
  border-bottom: 1px solid $bdcolor-light;
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    display: flex;
    justify-content: right;
    background-color: $bgcolor-dark;
    cursor: pointer;
  }

  .user {
    padding-right: $basespace-300;
  }

  .next-action-suggestion {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: $basespace-100 $basespace-300;
    overflow: hidden;
    width: 100%;

    .content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: $basespace-100;
      overflow: hidden;
      width: 100%;

      .expand-text {
        min-height: 20px;
        width: 100%;
      }
    }
  }

  .priority-preview {
    display: flex;
    align-items: center;

    &.micro {
      font-size: $fontsize-100;
      line-height: $fontsize-100;
    }
    .priority-name {
      flex: 1;
      color: $textcolor-light;
    }
    .placeholder {
      color: $concrete-dark;
    }
  }
}
</style>
